export default __webpack_public_path__ + "static/media/SlideTwo.18a3937c.png";